import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    summaryList: () => {
        return HTTP.get('/work_time/ConclusionWorkList', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    summaryStatus: (id) => {
        return HTTP.post('/work_time/conclusionSalaryStatusUpdate/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    createSummaryEmployee: (type,month) => {
        return HTTP.get('/work_time/make_summarize_employee?type='+type+'&month='+month, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    createSummaryPartTime: (type,start_date,end_date) => {
        return HTTP.get('/work_time/make_summarize_employee?type='+type+'&start_date='+start_date+'&end_date='+end_date, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailEmployeeOrPartTime: (id) => {
        return HTTP.get('/work_time/ConclusionWorkDetail/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editDeductionItemEmployeeOrPartTime: (id,data) => {
        return HTTP.post('/work_time/deductionUpdate/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailDeductionItemEmployeeOrPartTime: (id) => {
        return HTTP.get('/work_time/conclusionWorkListsEdit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    summaryEmployee: (data) => {
        return HTTP.post('/work_time/ConclusionWorksSummarize',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}